// extracted by mini-css-extract-plugin
export default {"file":"File-module__file__n-Qo5","invalid":"File-module__invalid__cJ68U"};